// React
import React from 'react';
// External
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import EngravingOptionsComponent from 'components/engraving/EngravingOptions/EngravingOptions';
import FooterBtnActions from 'components/shared/molecules/FooterBtnActions/FooterBtnActions';
import { updateEngraving } from 'stores/actions';

class EngravingOptions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nextStepPath: ''
        };
        this.setSteps(props.engraving.productId);
        this.formComponent = React.createRef();
    }

    componentDidMount() {
    }

    async onSubmit() {
        if (!this.formComponent || !this.formComponent.current) {
            return null;
        }
        const formData = await this.formComponent.current.handleSubmit();
        if (formData) {
            this.props.updateEngraving(formData);
            this.navigateTo(`/engraving/${this.state.nextStepPath}`);
        }
    }

    /**
     * Sets the nexy step navigation. Only when the image option is available it will set the value to
     * navigate to image options, otherwise it'll be to final approval
     */
    setSteps(productId) {
        if (!productId) {
            return;
        }
        fetch('../fpc_config.json')
            .then((r) => r.json())
            .then((data) => {
                const selectedConfig = data.Config_File.find((x) => x.SugarID === productId);
                if (!selectedConfig) {
                    return;
                }
                this.setState({
                    nextStepPath: selectedConfig.PhotoSize === '0' ? 'final-approval' : 'image-options'
                });
            }).catch((err) => {
                console.error(err);
            });
    }

    navigateTo(path) {
        this.props.history.push({
            pathname: path,
            search: this.props.location.search
        });
    }

    render() {
        return (
            <div className="main-container">
                <NavbarPrimary hideNav />
                <div className="body-content engraving">
                    <PageTitle title="Engraving approval" />

                    <ContentCard
                        className="mt-62"
                        headerTitle="Customise Text"
                        divider={false}
                    >
                        <Container fluid className="engraving-container customise-text-container">
                            <EngravingOptionsComponent
                                wrappedComponentRef={this.formComponent}
                            />
                        </Container>
                    </ContentCard>
                </div>

                <FooterBtnActions
                    prevBtnOnCLick={() => this.navigateTo('/engraving/customise-text')}
                    nextBtnOnCLick={() => this.onSubmit()}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    engraving: state.engraving
});

const mapDispatchToProps = (dispatch) => {
    return {
        updateEngraving: (engravingObj) => dispatch(updateEngraving(engravingObj))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EngravingOptions));
